import eveningCupUrl from "../../assets/icons/evening.svg";

export default function EveningCupIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={eveningCupUrl}
      alt=""
      className={className}
      aria-hidden="true"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
        objectFit: "contain",
      }}
    />
  );
}
